import { BoxTheme } from '@lub0v/santa-utils';

/** Add a season here and a loader in registry.ts. Artwork belongs in its package. */
export type Season = 'candy' | 'egypt' | 'pixel' | 'cherry-blossom' | 'halloween' | 'winter' | 'alpine';
// Candy remains a recognized stored theme type, but is disabled in the UI.
export const SEASONS: readonly Season[] = ['alpine', 'egypt', 'pixel', 'cherry-blossom', 'halloween', 'winter'] as const;
export const DEFAULT_SEASON: Season = 'alpine';
/** Games without an explicit theme never inherit the account/site season. */
export const DEFAULT_GAME_SEASON = BoxTheme.HALLOWEEN;
export const SEASON_STORAGE_KEY = 'santa_season';
export function isSeason(value: unknown): value is Season {
  return typeof value === 'string' && (SEASONS as readonly string[]).includes(value);
}
export function readStoredSeason(): Season | null {
  try {
    const value = localStorage.getItem(SEASON_STORAGE_KEY);
    return isSeason(value) ? value : null;
  } catch {
    return null;
  }
}
export function storeSeason(season: Season) {
  try {
    localStorage.setItem(SEASON_STORAGE_KEY, season);
  } catch {
    /* Storage is optional. */
  }
}
